<template>
  <div class="border-b py-3 mb-3 text-red-400 text-xs"><b>* </b>Campo obrigatório.</div>
</template>

